
import { defineComponent } from "vue";
import AtLogoCard from "@/components/AtLogoCard.vue";

export default defineComponent({
  name: "Home",
  components: { AtLogoCard },
});
